import axios from 'axios';
import { useEffect, useState } from 'react'
import Table from 'react-bootstrap/Table'
import core from '../../core';
import "./Users.css"
import { Pagination, Stack } from "@mui/material";
import AddNewUser from './AddNewUser';
import { useDispatch, useSelector } from 'react-redux';
import { notificationActions } from "../../data/notification";
import { Search, ThreeDotsVertical, Plus } from 'react-bootstrap-icons';
import OutsideClickHandler from 'react-outside-click-handler';
import { Button, Modal } from 'react-bootstrap';
import useViewMode from '../../hooks/useViewMode';
import ViewToggle from '../../components/DataView/ViewToggle';
import DataCards from '../../components/DataView/DataCards';
import useT from "../../i18n/useT";

const Users = () => {
    const t = useT();
    const [filter, setFilter] = useState({limit: 10, page: 1, keyword: "", asc: "desc", calculator_category: "", role: "", sort_by: "id"})
    const [users, setUsers] = useState([]);
    const [paginator, setPaginator] = useState({from: 0, to: 0, total: 0, pages: 1});
    const [loading, setLoading] = useState(false);
    const [showUserModal, setShowUserModal] = useState(false);
    const [formData, setFormData] = useState({name: "", surname: "", superviser_fee: "", email: "", username: "", phone: "", password: "", calculator_category: "", role: "", identity_number: ""})
    const dispatch = useDispatch();
    const lang = useSelector((state) => state.user.language);
    const [createdUsersCount, setCreatedUsersCount] = useState(0);
    const [loadingCreateUser, setLoadingCreateUser] = useState(false);
    const [keyword, setKeyword] = useState("");
    const [actionsId, setActionsId] = useState("");
    const [actionType, setActionType] = useState("add");
    const [showConfirmationModal, setShowConfirmationModal] = useState(false);
    const {view, setView, isMobile} = useViewMode("users-view");

    const rowActions = (user) => (
        <div className='table-actions-block'>
            <ThreeDotsVertical height={"19px"} onClick={() => setActionsId(user.id)} style={{cursor: "pointer"}}/>
            {actionsId === user.id && <OutsideClickHandler onOutsideClick={() => setActionsId("")}>
                <div className='table-actions-dropdown'>
                    <div className='table-actions-item' onClick={() => {
                        setActionsId("");
                        setActionType("edit");
                        setFormData({...user});
                        setShowUserModal(true);
                    }}>{t("common.edit")}</div>
                    <div className='table-actions-item' onClick={() => {
                        setActionsId("");
                        setFormData({...user});
                        setShowConfirmationModal(true);
                    }}>{t("common.delete")}</div>
                </div>
            </OutsideClickHandler>}
        </div>
    );

    const cardFields = [
        {label: t("users.email"), value: (u) => u.email},
        {label: t("users.username"), value: (u) => u.username},
        {label: t("users.supFee"), value: (u) => `${u.superviser_fee}$`},
        {label: t("users.lastLoginDate"), value: (u) => u.last_login_time !== null ? core.formdatDate(u.last_login_time, "yyyy-mm-dd hr:min") : t("table.noData")},
        {label: t("users.lastPurchaseDate"), value: (u) => u.last_purchase_date !== null ? core.formdatDate(u.last_purchase_date, "yyyy-mm-dd hr:min") : t("table.noData")},
        {label: t("users.role"), value: (u) => u.role},
        {label: t("users.debt"), value: (u) => u.debt},
    ];

    const handlers = {
        createUser(e){
            e.preventDefault();
            setLoadingCreateUser(true);
            axios.post('/api/users', formData)
                .then((res) => {
                    setShowUserModal(false);
                    setLoadingCreateUser(false);
                    dispatch(notificationActions.changeNotification({show: true, text: res.data.message[lang], type: "success-notification"}))
                    setTimeout(() => {
                        dispatch(notificationActions.changeNotification({show: false, text: "", type: ""}))
                    }, 4000);
                    setCreatedUsersCount((prev) => prev + 1)
                })
                .catch((err) => {
                    setLoadingCreateUser(false);
                    dispatch(notificationActions.changeNotification({show: true, text: err.response.data.message[lang], type: "error-notification"}))
                    setTimeout(() => {
                        dispatch(notificationActions.changeNotification({show: false, text: "", type: ""}))
                    }, 4000);
                })
        },
        modifyUser(e){
            e.preventDefault();
            setLoadingCreateUser(true);
            axios.put(`/api/users/${formData.id}`, formData)
                .then((res) => {
                    setLoadingCreateUser(false);
                    setShowUserModal(false);
                    dispatch(notificationActions.changeNotification({show: true, text: res.data.message[lang], type: "success-notification"}))
                    setTimeout(() => {
                        dispatch(notificationActions.changeNotification({show: false, text: "", type: ""}))
                    }, 4000);
                    setCreatedUsersCount((prev) => prev + 1)
                })
                .catch((err) => {
                    setLoadingCreateUser(false);
                    dispatch(notificationActions.changeNotification({show: true, text: err.response.data.message[lang], type: "error-notification"}))
                    setTimeout(() => {
                        dispatch(notificationActions.changeNotification({show: false, text: "", type: ""}))
                    }, 4000);
                })
        },
        deleteUser(){
            setLoadingCreateUser(true);
            axios.delete(`/api/users/${formData.id}`)
                .then((res) => {
                    setLoadingCreateUser(false);
                    setShowConfirmationModal(false);
                    dispatch(notificationActions.changeNotification({show: true, text: res.data.message[lang], type: "success-notification"}))
                    setTimeout(() => {
                        dispatch(notificationActions.changeNotification({show: false, text: "", type: ""}))
                    }, 4000);
                    setCreatedUsersCount((prev) => prev + 1)
                })
                .catch((err) => {
                    setLoadingCreateUser(false);
                    setShowConfirmationModal(false);
                    dispatch(notificationActions.changeNotification({show: true, text: err.response.data.message[lang], type: "success-notification"}))
                    setTimeout(() => {
                        dispatch(notificationActions.changeNotification({show: false, text: "", type: ""}))
                    }, 4000);
                })
        }
    }

    useEffect(() => {
        setLoading(true);
        axios.get(`/api/users?limit=${filter.limit}&page=${filter.page}&keyword=${filter.keyword}&asc=${filter.asc}&calculator_category=${filter.calculator_category}&role=${filter.role}&sort_by=${filter.sort_by}`)
            .then((res) => {
                setLoading(false);
                setUsers(res.data.data);
                const fromItems = ((filter.page - 1) * filter.limit) + 1;
                const toItems = res.data.total < filter.page * filter.limit ? res.data.total :  filter.page * filter.limit;
                const pagesCount = res.data.total % filter.limit === 0 ? res.data.total / filter.limit : parseInt((res.data.total / filter.limit) + 1);
                setPaginator({from: fromItems, to: toItems, total: res.data.total, pages: pagesCount});
            })
            .catch((err) => {

            })
    }, [filter, createdUsersCount]);

    return(
        <div className="page-content-main-container">
            <h2 className="page-title">{t("users.title")}</h2>
            <div className="table-filter-container">
                <button className='btn btn-primary' style={{display: "flex", alignItems: "center", marginRight: "15px"}} onClick={() => {
                    setShowUserModal(true);
                    setFormData({name: "", surname: "", superviser_fee: "", email: "", username: "", phone: "", password: "", calculator_category: "", role: "", identity_number: ""});
                    setActionType("add");
                }}><Plus style={{fontSize: "20px", fontWeight: "bold"}} /> <span>{t("common.addNew")}</span></button>
                <ViewToggle view={view} setView={setView} isMobile={isMobile} />
                <div className='search-by-keyword'>
                    <input placeholder={t("common.search")} type='text' onKeyDown={(e) => {
                        if(e.keyCode === 13){
                            setFilter((prev) => ({...prev, keyword: keyword}));
                        }
                    }} value={keyword} className='form-control' onChange={(e) => setKeyword(e.target.value)} />
                    <button onClick={() => setFilter((prev) => ({...prev, keyword: keyword}))}><Search /></button>
                </div>
            </div>
            {view === "table" ? (
            <Table responsive>
                <thead>
                    <tr>
                        <th>{t("users.id")}</th>
                        <th>{t("users.fullname")}</th>
                        <th>{t("users.email")}</th>
                        <th>{t("users.username")}</th>
                        <th>{t("users.supFee")}</th>
                        <th>{t("users.lastLoginDate")}</th>
                        <th>{t("users.lastPurchaseDate")}</th>
                        <th>{t("users.role")}</th>
                        <th>{t("users.debt")}</th>
                        <th></th>
                    </tr>
                </thead>
                <tbody>
                    {
                        loading && <tr><td colSpan={8}><div style={{display: "flex", justifyContent: "center", alignItems: "center"}}><div className="loader" role=""></div></div></td></tr>
                    }
                    {
                        (users.length > 0 && !loading) && users.map((user) => {
                            return(
                                <tr key={user.identity_number}>
                                    <td>{user.id}</td>
                                    <td>{user.name} {user.surname}</td>
                                    <td>{user.email}</td>
                                    <td>{user.username}</td>
                                    <td>{user.superviser_fee}$</td>
                                    <td>{user.last_login_time !== null ? core.formdatDate(user.last_login_time, "yyyy-mm-dd hr:min") : t("table.noData")}</td>
                                    <td>{user.last_purchase_date !== null ? core.formdatDate(user.last_purchase_date, "yyyy-mm-dd hr:min") : t("table.noData")}</td>
                                    <td>{user.role}</td>
                                    <td>{user.debt}</td>
                                    <td>{rowActions(user)}</td>
                                </tr>
                            )
                        })
                    }
                    {
                        (!loading && users.length === 0) && <tr><td colSpan={8} style={{textAlign: "center"}}>{t("table.notFound")}</td></tr>
                    }
                </tbody>
            </Table>
            ) : (
                <DataCards layout={view}
                    items={loading ? [] : users}
                    loading={loading}
                    getKey={(u) => u.identity_number}
                    renderTitle={(u) => u.id}
                    renderSubtitle={(u) => `${u.name} ${u.surname}`}
                    fields={cardFields}
                    renderActions={(u) => rowActions(u)}
                />
            )}
            <div className="pagination-container">
                <div className="paginatior-left-size">
                    <p className="showing-items-text">{t("table.showing")} {paginator.from} {t("table.of")} {paginator.to}</p>
                    <span style={{margin: "0 12px"}}>{t("table.total")}: {paginator.total}</span>
                    <span>{t("table.show")}:</span>
                    <select value={filter.limit} onChange={(e) => setFilter((prev) => ({...prev, limit: e.target.value}))} className="form-control" style={{width: "50px"}}>
                        <option value={10}>10</option>
                        <option value={20}>20</option>
                        <option value={30}>30</option>
                        <option value={50}>50</option>
                    </select>
                </div>
                <Stack spacing={2}>
                    <Pagination count={paginator.pages} page={filter.page} onChange={(value, p) => setFilter((prev)=>({...prev, page: p}))} />
                </Stack>
            </div>
            <AddNewUser type={actionType} loading={loadingCreateUser} submit={actionType === "add" ? handlers.createUser : handlers.modifyUser} formData={formData} setFormData={setFormData} show={showUserModal} setShow={setShowUserModal} />
            <Modal show={showConfirmationModal} onHide={() => setShowConfirmationModal(false)} >
                <Modal.Header closeButton><h3>{t("users.removeTitle")}</h3></Modal.Header>
                <Modal.Body><p>{t("users.removeConfirm")}</p></Modal.Body>
                <Modal.Footer>
                    <Button type='button' onClick={handlers.deleteUser} variant={loadingCreateUser ? 'secondary' : 'primary'} disabled={loadingCreateUser}>{loadingCreateUser ? <div className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></div> : t("common.yes")}</Button>
                    <Button type='button' onClick={() => setShowConfirmationModal(false)} variant='danger'>{t("common.no")}</Button>
                </Modal.Footer>
            </Modal>
        </div>
    )
}

export default Users